import styled from "styled-components";

// 수업자료 Tree
export const BoardClassTreeWrapper = styled.div`
.ant-tree {
  background-color: unset !important;
  padding: 1rem 4rem;
}
.ant-tree-node-content-wrapper {
  border: 1px solid black !important;
  border-radius: 5px !important;

  &.ant-tree-node-selected {
    border: 1px solid lightseagreen !important;
    border-radius: 5px !important;
  }
}
.ant-tree-treenode-selected {
  &::before {
    background-color: unset !important;
  }
  .ant-tree-switcher {
    color: unset !important;
  }
}
.ant-tree-node-selected {
  background-color: lightseagreen !important;
}
.ant-tree-title, .ant-tree-switcher-line-icon {
  font-size: 1.5rem !important;
}
.ant-tree-switcher {
  display: flex;
  justify-content: center;
}
`;

// 문의 상세페이지 답변 backgroundColor
export const ReplyAttachmentWrapper = styled.div`
.ant-table-cell {
  background-color: whitesmoke !important;
}
`;

// noShowHeader Table border
export const NoHeaderTableWrapper = styled.div`
.ant-table-cell {
  border-bottom: 1px solid var(--color-gray10) !important;
  border-right: 1px solid var(--color-gray10) !important;
}

.ant-table-content {
  border-left: 1px solid var(--color-gray10) !important;
}
`;

// 교재 주문관리 수정 Table
export const OrderUpdateTableWrapper = styled.div`
tbody .ant-table-cell {
  background-color: var(--color-red05) !important;
}
`;

// 교재 주문관리 교재 선택 Table
export const OrderBookTableWrapper = styled.div`
.require-column {
  background-color: var(--color-orange01) !important;
}
`;

// 교재주문 교환(오배송) Table
export const ExchangeOrderTableWrapper = styled.div`
.ant-table {
	margin: 0 !important;
}
.require-column {
  background-color: var(--color-orange01) !important;
}
`;

// 교재 주문관리 STEP Dot
export const StepDotWrapper = styled.div`
.ant-steps-icon {
  top: 10px !important;
}
`;

// 교재 주문관리 기타/물품 Collapse
export const OrderBookCollapseWrapper = styled.div`
  .ant-collapse-header {
    padding: 0 !important;
    display: flex !important;
    align-items: center !important;

    .ant-collapse-expand-icon {
      padding: 0 5px 0 0 !important;
    }
  }

  .ant-collapse-content-box {
    padding: 12px 0 !important;
    line-height: 1;
  }
`;